import React from 'react';
import { OnDemandScreenPage } from './ondemand/OnDemandScreenPage';
import { OnDemandScreensPage } from './ondemand/OnDemandScreensPage';

/** Beam on Screen → On Demand Player (`/#/beamonscreen/ods`). */
export const OnDemandPlayer: React.FC = () => <OnDemandScreensPage />;

/** Beam on Screen → one screen (`/#/beamonscreen/ods/:screenId`). */
export const OnDemandScreenDetail: React.FC = () => <OnDemandScreenPage />;
